import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Alert } from 'reactstrap';
import {
  withLoading,
  useAppContext,
  useTranslator,
  removeAuthCredentials,
  useToast,
} from '@front-activerse/common-components';
import Layout from '../../Layout/Layout';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';

import { useOutletContext } from 'react-router-dom';

const BuyThankYouPresaleContainer = ({ reportPayment, token }) => {
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();
  const { toastError } = useToast();

  const {
    images: { presaleThankYouPageBg, presaleThankYouPageBgMobile },
  } = useAppContext();

  const handleReportPayment = async () => {
    try {
      const res = await reportPayment({ token });
      const result = res.data.sale.reportPayment;
      if (!result) {
        window.location = import.meta.env.VITE_LANDING_PAGE_URL;
        return null;
      }

      const type = result.__typename;

      if (type === 'NotReportedPayment') {
        if (result.reportData) {
          result.reportData = result.reportData.map(JSON.parse);
          result.reportData.forEach((data) => window.dataLayer.push(data));

          const userEmail = global.localStorage.getItem('userEmail');

          window.dataLayer.push({
            event: 'conversion',
            email: userEmail || '',
          });

          trackFirebaseEvent('screen_view', {
            firebase_screen: 'stripe_success',
          });
        }
      } else if (type === 'CanceledPayment') {
        throw new Error('Unexpected response. Typename: CanceledPayment');
      } else if (type === 'ValidationException') {
        toastError(t('app.thankUPage.paymentToken.error'));
        throw new Error('ValidationException');
      }
      return null;
    } catch (err) {
      throw new Error(err);
    }
  };

  useEffect(() => {
    handleReportPayment();
    removeAuthCredentials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout simpleLayout>
      <div className="page-template-buy full-height7">
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 6, offset: 3 }}>
              <div className="thankyou-container-presale">
                <section>
                  <img
                    src={presaleThankYouPageBg}
                    alt=""
                    className="img-fluid d-none d-md-block mb-xxl rounded"
                  />
                  <img
                    src={presaleThankYouPageBgMobile}
                    alt=""
                    className="img-fluid d-md-none mb-xxl rounded"
                  />
                  <h1 className="title-medium semi-bold text-center mb-xl">
                    {t('presale.thankUPage.title')}
                  </h1>
                  <p className="text-center">{t('presale.thankUPage.description.part1')}</p>
                </section>

                <div className="box-surface">
                  <h2 className="title-medium semi-bold text-center mb-xl">
                    {t('presale.thankUPage.infoBox.title')}
                  </h2>
                  <p className="text-center mb-xl">{t('presale.thankUPage.infoBox.description')}</p>
                  <Alert color="info">
                    <p>{t('presale.thankUPage.infoBox.notification')}</p>
                  </Alert>
                </div>

                <p className="text-center">{t('presale.thankUPage.description.part2')}</p>
                <p className="text-center">{t('presale.thankUPage.description.part3')}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

BuyThankYouPresaleContainer.propTypes = {
  reportPayment: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  trackFirebaseEvent: PropTypes.func.isRequired,
};

const Placeholder = () => <UniversalPlaceholder simpleLayout fullHeightMinusHeader />;

export default withLoading(BuyThankYouPresaleContainer, Placeholder);
